export const CALCULATE_PROVISION = 'CALCULATE_PROVISION';
export const CALCULATE_PROVISION_FAILURE = 'CALCULATE_PROVISION_FAILURE';
export const CALCULATE_PROVISION_SUCCESS = 'CALCULATE_PROVISION_SUCCESS';
export const UPLOAD_TRIAL_BALANCE_FILE_SUCCESS = 'UPLOAD_TRIAL_BALANCE_FILE_SUCCESS';
export const UPLOAD_TRIAL_BALANCE_FILE_FAILURE = 'UPLOAD_TRIAL_BALANCE_FILE_FAILURE';
export const PROFORMA_CALC = 'PROFORMA_CALC';

export const DOWNLOAD_PROVISION_DETAILS = 'DOWNLOAD_PROVISION_DETAILS';
export const DOWNLOAD_PROVISION_DETAILS_FAILURE = 'DOWNLOAD_PROVISION_DETAILS_FAILURE';
export const DOWNLOAD_PROVISION_DETAILS_SUCCESS = 'DOWNLOAD_PROVISION_DETAILS_SUCCESS';
